<template>
  <ul>
    <li v-for="(store, i) in stores" :key="store.storeid">
      <bopis-store-details
        enable-selection
        :index="i"
        :model-value="selectedStore"
        :show-address-preview
        :store
        @update:model-value="(value) => selectedStore = value"
      />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { LocatorSearchItem } from '#types/brandify'

defineProps<{
  stores: LocatorSearchItem[]
  showAddressPreview?: boolean
}>()

const selectedStore = defineModel<LocatorSearchItem>()
</script>
